import React, { useContext, useEffect } from "react";
import ApiConfig from "../api/ApiConfig";
import {
  PostCallWithAuthToken,
  PostCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithToken,
} from "../api/ApiServices";
import { Form, FormGroup, Modal } from "react-bootstrap";
import { productOnChangeHandler } from "../pages";
import { singleProductHandler } from "../common";
import { useState } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { ToastMsg } from "../pages/TostMsg";

const ProductTable = ({
  isStateSame,
  productDetails,
  setProductDetails,
  units,
  currentRoute,
  appSettings,
  addNewRow,
  setBackDropOpen,
  errMsg,
  permissions,
  setErrMsg,
  DeleteHandler,
  invoiceFormDetails,
}) => {
  const { productNameWidth, setHideBothSide, setProductNameWidth, setSidebar } =
    useContext(AppContext);
  const [productValidated, setProductValidated] = useState(false);

  const [discountVal, setDiscountVal] = useState(JSON.parse(localStorage.getItem("appSettings")) || {});
  useEffect(() => {
    const storedValue = JSON.parse(localStorage.getItem("appSettings"));
    if (storedValue) {
      setDiscountVal(storedValue);
    }
  }, []);
  console.log("productValidated,", productValidated)
  const [products, setProducts] = useState([]);
  const [addedNew, setAddedNew] = useState(false);

  const [account, setAccount] = useState([]);
  const [hsnCodes, setHsnCodes] = useState([]);
  const [newProduct, setNewProduct] = useState({
    productCode: "",
    productName: "",
    rate: 0,
    ledgerAccId: 0,
    taxRate: "",
    hsnCode: "",
    hsnId: 0,
    unit: "",
    unitId: 0
  });


  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target.form;
    if (form.checkValidity() === false) {
      // form.reset();
      event.preventDefault();
      event.stopPropagation();
    } else {

      PostCallWithAuthToken(
        ApiConfig.ADD_NEW_PRODUCT,
        JSON.stringify(newProduct)
      )
        .then((res) => {
          if (res.json.success) {
            ToastMsg("success", "Product added successfully");
            setAddedNew(false);
            getProducts();
          }
        })
        .catch((err) => console.log(err))
        .finally(() => form.reset());
    }
    setProductValidated(true);
  };

  useEffect(() => {
    getProducts();
    getAccounts();
    getHsnCodes();
  }, []);

  const getProducts = () => {
    simpleGetCallWithToken(ApiConfig.GET_PRODUCTS)
      .then((res) => {
        if (res.success && res.success === true) {
          setProducts(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const getAccounts = () => {
    simpleGetCallWithToken(ApiConfig.GET_ACCOUNT)
      .then((res) => {
        if (res.success === true) {
          setAccount(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const getHsnCodes = () => {
    simpleGetCallWithToken(ApiConfig.GET_HSNCODE)
      .then((res) => {
        setHsnCodes(res.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="detail-tab-con">
        {errMsg.products && (
          <span
            className="text-danger"
            style={{ fontSize: "12px", marginLeft: "5px" }}
          >
            {errMsg.products}
          </span>
        )}
        <table className="table-scroll">
          <thead>
            <tr className="heading-row">
              <td className="number">Sr. No.</td>
              <td style={{ width: productNameWidth ? "320px" : "170px" }}>
                Product Name
              </td>
              <td>
                {currentRoute === "/SalesServices" || currentRoute === "/PurchaseServices"
                  ? "SAC"
                  : currentRoute === "/SalesGoods" || currentRoute === "/purchaseGoods"
                    ? "HSN"
                    : "HSN/SAC"}
                {/* "/purchaseGoods" || "/PurchaseServices" */}
              </td>


              <td>Quantity  </td>
              <td>Rate</td>
              <td>Unit</td>
              {appSettings && appSettings?.isDiscount && <td style={{ width: '60px' }}>Disc. <span>{discountVal.discType === "Amount" ? `(₹)` : `(%)`}</span> </td>}
              <td>Amount</td>




              {/* // {!isStateSame || invoiceFormDetails?.isSEZEnabled ? (
                
              //   <td colSpan="2">IGST</td>
              // ) : (
              //   <>
              //     <td colSpan="2">CGST</td>
              //     <td colSpan="2">SGST</td>
              //   </>
              // )}; */}

              {appSettings && appSettings.isGSTApplicable &&
                (!isStateSame || invoiceFormDetails?.isSEZEnabled) ? (
                <td colSpan="2">IGST</td>
              ) : (
                <>
                  {appSettings && appSettings.isGSTApplicable && (
                    <td colSpan="2">CGST</td>)}
                  {appSettings && appSettings.isGSTApplicable && (
                    <td colSpan="2">SGST</td>)}
                </>
              )}



              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            {productDetails &&
              productDetails.length &&
              productDetails.map((itemAdded, index) => {
                const discountType = appSettings?.discType === "Amount" ? true : false
                return (
                  <tr key={"productDetails" + index}>
                    <td className="number">{index + 1}</td>
                    <td>
                      <input
                        name="productName"
                        type="text"
                        className="form-control"
                        placeholder="Enter product name"
                        value={itemAdded.productName}
                        list="productList"
                        // onFocus={() => {
                        //   setHideBothSide({
                        //     lg: "12",
                        //     displayBlock: "none",
                        //   });
                        //   setProductNameWidth(true);
                        //   setSidebar(false);
                        // }}
                        // onBlur={() => {
                        //   setHideBothSide({
                        //     lg: "8",
                        //     displayBlock: "",
                        //   });
                        //   setProductNameWidth(false);
                        //   setSidebar(true);
                        // }}
                        onChange={(e) => {
                          if (e.target.value === "Add New Product")
                            setAddedNew(true);
                          else {
                            setProductDetails(
                              productDetails.map((item, innerIndex) => {
                                if (innerIndex === index)
                                  return {
                                    ...item,
                                    productName: e.target.value,
                                  };
                                else return item;
                              })
                            );
                            let productIndex;
                            let product = products.filter((item, index) => {
                              if (item.productName === e.target.value) {
                                productIndex = index;
                                return item;
                              }
                            })[0];

                            product &&
                              singleProductHandler(
                                product,
                                index,
                                setBackDropOpen,
                                setProductDetails,
                                productDetails,
                                isStateSame,
                                appSettings
                              );
                          }
                          setErrMsg({ ...errMsg, products: "" });
                        }}
                      />
                      {/* <div id="productList1"> */}

                      <datalist id="productList" className="datalist-product">
                        {permissions?.includes("Create Product") ? (
                          <option value="Add New Product" />
                        ) : null}

                        {products &&
                          products.map((productItem) => {
                            return (
                              <>
                                <option>{productItem.productName}</option>
                              </>
                            );
                          })}
                      </datalist>
                    </td>

                    <td>
                      <input
                        name="hsnCode"
                        type="text"
                        className="form-control"
                        placeholder={currentRoute === "/SalesServices" || currentRoute === "/PurchaseServices"
                          ? "SAC"
                          : currentRoute === "/SalesGoods" || currentRoute === "/purchaseGoods"
                            ? "HSN"
                            : "HSN/SAC"}
                        value={itemAdded.productName ? itemAdded.hsnCode : ""}
                        // onFocus={(e) => {
                        //   if (
                        //     index + 1 === productDetails.length &&
                        //     itemAdded.productName.length > 1
                        //   ) {
                        //     addNewRow(e);
                        //   }
                        //   setHideBothSide({
                        //     lg: "12",
                        //     displayBlock: "none",
                        //   });
                        //   setProductNameWidth(true);
                        //   setSidebar(false);
                        // }}
                        // onBlur={() => {
                        //   setHideBothSide({
                        //     lg: "8",
                        //     displayBlock: "",
                        //   });
                        //   setProductNameWidth(false);
                        //   setSidebar(true);
                        // }}
                        onChange={(e) => {
                          setProductDetails(
                            productDetails.map((item, innerIndex) => {
                              return index === innerIndex
                                ? {
                                  ...item,
                                  hsnCode: e.target.value,
                                }
                                : item;
                            })
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        name="qty"
                        type="number"
                        className="form-control"
                        value={itemAdded.qty ? itemAdded.qty : 0}
                        onChange={(e) => {
                          if (!isNaN(e.target.value) && e.target.value >= 0) {

                            productOnChangeHandler(
                              e,
                              setProductDetails,
                              productDetails,
                              index,
                              isStateSame,
                              appSettings
                            );
                          }
                        }}
                      // onFocus={() => {
                      //   setHideBothSide({
                      //     lg: "12",
                      //     displayBlock: "none",
                      //   });
                      //   setProductNameWidth(true);
                      //   setSidebar(false);
                      // }}
                      // onBlur={() => {
                      //   setHideBothSide({
                      //     lg: "8",
                      //     displayBlock: "",
                      //   });
                      //   setProductNameWidth(false);
                      //   setSidebar(true);
                      // }}
                      />
                    </td>
                    <td>
                      <input
                        name="rate"
                        type="number"
                        min="1"
                        className="form-control"
                        placeholder="₹ 0.0"
                        value={itemAdded.rate ? itemAdded.rate : ""}
                        // value={itemAdded.rate && itemAdded.rate}
                        onChange={(e) => {
                          productOnChangeHandler(
                            e,
                            setProductDetails,
                            productDetails,
                            index,
                            isStateSame,
                            appSettings
                          );
                        }}
                      // onFocus={() => {
                      //   setHideBothSide({
                      //     lg: "12",
                      //     displayBlock: "none",
                      //   });
                      //   setProductNameWidth(true);
                      //   setSidebar(false);
                      // }}
                      // onBlur={() => {
                      //   setHideBothSide({
                      //     lg: "8",
                      //     displayBlock: "",
                      //   });
                      //   setProductNameWidth(false);
                      //   setSidebar(true);
                      // }}
                      />
                    </td>
                    <td>
                      <select
                        name="unitId"
                        className="form-control"
                        value={itemAdded.unitId ? itemAdded.unitId : ""}
                        style={{ width: "60px" }}
                        onChange={(e) => {
                          productOnChangeHandler(
                            e,
                            setProductDetails,
                            productDetails,
                            index,
                            isStateSame,
                            appSettings
                          );
                        }}
                      // onFocus={() => {
                      //   setHideBothSide({
                      //     lg: "12",
                      //     displayBlock: "none",
                      //   });
                      //   setProductNameWidth(true);
                      //   setSidebar(false);
                      // }}
                      // onBlur={() => {
                      //   setHideBothSide({
                      //     lg: "8",
                      //     displayBlock: "",
                      //   });
                      //   setProductNameWidth(false);
                      //   setSidebar(true);
                      // }}
                      >
                        <option value="">Select Unit</option>
                        {units &&
                          units.length > 0 &&
                          units.map((item, i) => {
                            return (
                              <option key={"units" + i} value={item.id}>
                                {item.unit}
                              </option>
                            );
                          })}
                        {/* <option value="">ml</option>
                                  <option value="">ak</option> */}
                      </select>
                    </td>
                    {appSettings && appSettings?.isDiscount && (
                      <td>
                        <input
                          name="discPer"
                          type="number"
                          className="form-control"
                          placeholder={`0${!discountType ? '%' : ''}`}
                          value={itemAdded.discPer ? itemAdded.discPer : "0"}
                          onChange={(e) => {
                            productOnChangeHandler(
                              e,
                              setProductDetails,
                              productDetails,
                              index,
                              isStateSame,
                              appSettings
                            );
                          }}
                        // onFocus={() => {
                        //   setHideBothSide({
                        //     lg: "12",
                        //     displayBlock: "none",
                        //   });
                        //   setProductNameWidth(true);
                        //   setSidebar(false);
                        // }}
                        // onBlur={() => {
                        //   setHideBothSide({
                        //     lg: "8",
                        //     displayBlock: "",
                        //   });
                        //   setProductNameWidth(false);
                        //   setSidebar(true);
                        // }}
                        />
                      </td>
                    )}
                    <td>
                      <input
                        disabled
                        name="discAmount"
                        type="text"
                        className="form-control"
                        placeholder="₹ 0.0"
                        value={
                          itemAdded.discAmount ? itemAdded.discAmount : `₹ ${0}`
                        }
                      />
                    </td>
                    {appSettings && appSettings?.isGSTApplicable &&
                      (!isStateSame || invoiceFormDetails?.isSEZEnabled) ? (

                      // {!isStateSame || invoiceFormDetails?.isSEZEnabled ? (
                      <>
                        <td>

                          <input
                            name="igst"
                            type="number"
                            className="form-control"
                            placeholder="0%"
                            value={itemAdded.igst ? itemAdded.igst : ""}
                            onChange={(e) => {
                              productOnChangeHandler(
                                e,
                                setProductDetails,
                                productDetails,
                                index,
                                isStateSame,
                                appSettings
                              );
                            }}
                          // onFocus={() => {
                          //   setHideBothSide({
                          //     lg: "12",
                          //     displayBlock: "none",
                          //   });
                          //   setProductNameWidth(true);
                          //   setSidebar(false);
                          // }}
                          // onBlur={() => {
                          //   setHideBothSide({
                          //     lg: "8",
                          //     displayBlock: "",
                          //   });
                          //   setProductNameWidth(false);
                          //   setSidebar(true);
                          // }}
                          />
                        </td>
                        {appSettings && appSettings.isGSTApplicable && (
                          <td>
                            <input
                              disabled
                              name="igstAmount"
                              type="text"
                              className="form-control"
                              placeholder="₹ 0.0"
                              value={
                                itemAdded.igstAmount ? itemAdded.igstAmount : 0
                              }
                            />
                          </td>)}
                      </>
                    ) : (
                      <>
                        {appSettings && appSettings.isGSTApplicable && (
                          <td>
                            <input
                              name="cgst"
                              type="number"
                              className="form-control"
                              placeholder="0%"
                              value={itemAdded.cgst ? itemAdded.cgst : ""}
                              onChange={(e) => {
                                productOnChangeHandler(
                                  e,
                                  setProductDetails,
                                  productDetails,
                                  index,
                                  isStateSame,
                                  appSettings
                                );
                              }}
                            // onFocus={() => {
                            //   setHideBothSide({
                            //     lg: "12",
                            //     displayBlock: "none",
                            //   });
                            //   setProductNameWidth(true);
                            //   setSidebar(false);
                            // }}
                            // onBlur={() => {
                            //   setHideBothSide({
                            //     lg: "8",
                            //     displayBlock: "",
                            //   });
                            //   setProductNameWidth(false);
                            //   setSidebar(true);
                            // }}
                            />
                          </td>)}
                        {appSettings && appSettings.isGSTApplicable && (
                          <td>
                            <input
                              disabled
                              name="cgstAmount"
                              type="text"
                              className="form-control"
                              placeholder="₹ 0.0"
                              value={
                                itemAdded.cgstAmount ? itemAdded.cgstAmount : 0
                              }
                            />
                          </td>)}
                        {appSettings && appSettings.isGSTApplicable && (
                          <td>
                            <input
                              name="sgst"
                              type="number"
                              className="form-control"
                              placeholder="0%"
                              value={itemAdded.sgst ? itemAdded.sgst : ""}
                              onChange={(e) => {
                                productOnChangeHandler(
                                  e,
                                  setProductDetails,
                                  productDetails,
                                  index,
                                  isStateSame,
                                  appSettings
                                );
                              }}
                            // onFocus={() => {
                            //   setHideBothSide({
                            //     lg: "12",
                            //     displayBlock: "none",
                            //   });
                            //   setProductNameWidth(true);
                            //   setSidebar(false);
                            // }}
                            // onBlur={() => {
                            //   setHideBothSide({
                            //     lg: "8",
                            //     displayBlock: "",
                            //   });
                            //   setProductNameWidth(false);
                            //   setSidebar(true);
                            // }}
                            />
                          </td>)}
                        {appSettings && appSettings.isGSTApplicable && (
                          <td>
                            <input
                              disabled
                              name="sgstAmount"
                              type="text"
                              className="form-control"
                              placeholder="₹ 000"
                              value={
                                itemAdded.sgstAmount ? itemAdded.sgstAmount : 0
                              }
                            />
                          </td>)}

                      </>

                    )}

                    <td>
                      <div
                        onClick={() => {
                          if (productDetails.length > 1) {
                            DeleteHandler(index);
                          } else {
                            setProductDetails([
                              {
                                id: 0,
                                hsnId: 0,
                                productId: 0,
                                gst: 0,
                                gstAmount: 0,
                                igst: 0,
                                igstAmount: 0,
                                sgst: 0,
                                sgstAmount: 0,
                                cgst: 0,
                                cgstAmount: 0,
                                discPer: 0,
                                discAmount: 0,
                                unitId: 0,
                                productName: "",
                                hsnCode: "",
                                qty: 0,
                                rate: 0,
                              },
                            ]);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                          <path
                            fillRule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                          />
                        </svg>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      <Link type="button" className="add-row-btn" onClick={addNewRow}>
        Add row
      </Link>

      {/* Modal Of Add new row*/}
      {addedNew ?
        <Modal
          show={true}
          size="lg"
          onHide={() => {
            setAddedNew(false)
          }}
          centered
          className="main-add-row-modal"
        >
          <Modal.Header closeButton onHide={() => setProductValidated(false)}>
            <Modal.Title id="example-modal-sizes-title-lg">
              New Product
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* <Form noValidate validated={productValidated} onSubmit={handleSubmit}> */}
            <Form noValidate validated={productValidated}>
              <FormGroup>
                <div className="add-row-content-modal">
                  {/* Two inputs */}
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="" className="label-add-row">
                          Product Code
                        </label>
                        <input
                          type="text"
                          className="form-control input-add-row"
                          required
                          onChange={(e) => {
                            setNewProduct({
                              ...newProduct,
                              productCode: e.target.value,
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide a product code.
                        </Form.Control.Feedback>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="" className="label-add-row">
                          Product Name
                        </label>
                        <input
                          type="text"
                          className="form-control input-add-row "
                          required
                          onChange={(e) => {
                            setNewProduct({
                              ...newProduct,
                              productName: e.target.value,
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide a product name.
                        </Form.Control.Feedback>
                      </div>
                    </div>
                  </div>

                  {/* Three Columns */}
                  <div className="row mt-4">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="" className="label-add-row">
                          Unit
                        </label>
                        <select
                          className="form-select input-add-row"
                          required
                          onChange={(e) => {
                            setNewProduct({
                              ...newProduct,
                              unitId: Number(e.target.value),
                              unit: units.filter((item) => {
                                return item.id === Number(e.target.value)
                                  ? item.unit
                                  : 0;
                              })[0].unit,
                            });
                          }}
                        >
                          <option value="">Select Unit</option>
                          {units &&
                            units.length > 0 &&
                            units.map((item, i) => {
                              return (
                                <option key={"units" + i} value={item.id}>
                                  {item.unit}
                                </option>
                              );
                            })}
                        </select>
                        <Form.Control.Feedback type="invalid">
                          Please select a unit.
                        </Form.Control.Feedback>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="" className="label-add-row">
                          Unit Price
                        </label>
                        <input
                          type="text"
                          className="form-control input-add-row"
                          required
                          onChange={(e) => {
                            setNewProduct({
                              ...newProduct,
                              rate: Number(e.target.value),
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide Unit Price.
                        </Form.Control.Feedback>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="" className="label-add-row">
                          Account
                        </label>
                        <select
                          className="form-select input-add-row"
                          required
                          onChange={(e) => {
                            setNewProduct({
                              ...newProduct,
                              ledgerAccId: Number(e.target.value),
                            });
                          }}
                        >
                          <option value="">Please select</option>
                          {account &&
                            account.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            ))}
                        </select>
                        <Form.Control.Feedback type="invalid">
                          Please provide an Account.
                        </Form.Control.Feedback>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-4">
                      <div className="form-group">
                        <label htmlFor="" className="label-add-row">
                          HSN Code
                        </label>
                        <select
                          className="form-select input-add-row"
                          required
                          onChange={(e) => {
                            setNewProduct({
                              ...newProduct,
                              hsnId: Number(e.target.value),
                              hsnCode: hsnCodes.filter((item) => {
                                return item.id === Number(e.target.value)
                                  ? item.taxRate
                                  : 0;
                              })[0].hsnCode,
                              taxRate: hsnCodes.filter((item) => {
                                return item.id === Number(e.target.value)
                                  ? item.taxRate
                                  : 0;
                              })[0].taxRate,
                            });
                          }}
                        >
                          <option value="">Please select</option>
                          {hsnCodes &&
                            hsnCodes.map((code) => (
                              <option value={code.id} key={code.id}>
                                {code.hsnCode}
                              </option>
                            ))}
                        </select>
                        <Form.Control.Feedback type="invalid">
                          Please provide HSN Code.
                        </Form.Control.Feedback>
                      </div>
                    </div>
                    <div className="col-md-4 mt-4">
                      <div className="form-group">
                        <label htmlFor="" className="label-add-row">
                          Tax Rate
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control input-add-row"
                          disabled
                          value={newProduct.taxRate}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide Tax Rate
                        </Form.Control.Feedback>
                      </div>
                    </div>
                  </div>

                  <Modal.Footer className="mt-4">
                    <button
                      // to="#"
                      className="cancelbtn text-center"
                      onClick={(event) => {
                        const form = event.target.form;
                        console.log("form,,", form)
                        form.reset();
                        setProductValidated(false);
                        setAddedNew(false)
                      }}
                    >
                      Cancel
                    </button>
                    <button className="savebtn text-center" onClick={handleSubmit}>
                      Save
                    </button>
                  </Modal.Footer>
                </div>
              </FormGroup>
            </Form>
          </Modal.Body>
        </Modal> : null}
    </>
  );
};

export default ProductTable;
